import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Clock, Users, CheckCircle, ArrowRight } from 'lucide-react'

const TemporaryStaffing = () => {
  const benefits = [
    'Quick access to qualified professionals',
    'Flexible staffing solutions',
    'Reduced hiring costs',
    'Minimal administrative burden',
    'Scalable workforce',
    'Industry expertise'
  ]

  return (
    <div>
      <section className="bg-gradient-to-br from-primary-800 via-primary-700 to-teal-700 text-white py-16 md:py-20">
        <div className="container-max">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">Temporary Staffing Solutions</h1>
            <p className="text-lg md:text-xl text-primary-100">Flexible workforce solutions for your business needs</p>
            <div className="w-20 h-1 bg-accent-500 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary-800 mb-6">Why Choose Our Temporary Staffing?</h2>
              <p className="text-secondary-500 mb-6">Get the right people, at the right time, for the right duration. Our temporary staffing solutions help you maintain productivity during peak periods, cover for absences, or handle special projects.</p>
              <ul className="space-y-3">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-600">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Temporary Staffing" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default TemporaryStaffing
